import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        background: '#F9F9F9',
        primary: '#1b8e8a',
        secondary: '#424242',
        accent: '#1b8e8a',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
      dark: {
        background: '#333333',
        primary: '#1b8e8a',
        secondary: '#424242',
        accent: '#1b8e8a',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
});
